import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=4688eb66&scoped=true&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"
import style0 from "./goods.vue?vue&type=style&index=0&id=4688eb66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4688eb66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4688eb66')) {
      api.createRecord('4688eb66', component.options)
    } else {
      api.reload('4688eb66', component.options)
    }
    module.hot.accept("./goods.vue?vue&type=template&id=4688eb66&scoped=true&", function () {
      api.rerender('4688eb66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/special/components/goods.vue"
export default component.exports